import { Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DutchDateAdapter } from '@mango/core';

/**
 * Mango's own screens (the list wrapper, filters) bring the native Date adapter of Material in a standalone injector below
 * the app's root injector, so date pickers inside them showed English-style calendars with single letter weekdays. Components
 * that host date pickers or date filters list these providers: the moment based adapter of the Angular 12 app (Dutch
 * weekdays "ma di wo", months "NOV.", Monday first).
 */
export const DUTCH_DATE_PROVIDERS: Provider[] = [
    { provide: DateAdapter, useClass: DutchDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
];
